import { render, staticRenderFns } from "./AddLicence.vue?vue&type=template&id=bbcacaf0&"
import script from "./AddLicence.vue?vue&type=script&lang=js&"
export * from "./AddLicence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports